import React from 'react';
import {
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Grid,
} from '@material-ui/core';
import styled from 'styled-components';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { MarketData } from '../../types';
import InfoHeader from './InfoContents/InfoHeader';
import ReactMarkdown from 'react-markdown';

const useStyles = makeStyles((theme) => ({
  buttons: {
    justifyContent: 'space-between',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  expansionHeader: {
    alignItems: 'center',
  },
  infoRows: {
    flexDirection: 'column',
  },
  contactButtonContainer: {
    marginTop: '10px',
  },
}));

interface OfficeInfoProps {
  selectedMarket: MarketData;
  closePopoutButton: React.ReactElement;
}

const DesktopMarketInfo = ({
  selectedMarket,
  closePopoutButton,
}: OfficeInfoProps) => {
  const classes = useStyles({});

  return (
    <div
      style={{
        backgroundColor: '#f7f5f3',
      }}
    >
      <InfoHeader
        selectedMarket={selectedMarket}
        closePopoutButton={closePopoutButton}
      />
      <Grid
        item
        container
        alignItems="flex-start"
        direction="column"
        justifyContent="flex-start"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid container justifyContent="center" alignItems="center">
            <div>
              <MarketName variant="h2">{selectedMarket.name}</MarketName>
            </div>
          </Grid>
          <Grid container justifyContent="center" alignItems="center">
            <PopulationGdpContainer>
              <GDP>
                USD {selectedMarket.GDP} billion ({selectedMarket.year} GDP)
              </GDP>
              <Population>
                {selectedMarket.population} million ({selectedMarket.year}{' '}
                Population )
              </Population>
            </PopulationGdpContainer>
          </Grid>
        </Grid>
        <Grid container direction="row">
          <div style={{ backgroundColor: '#f7f5f3' }}>
            <Grid>
              <ConsumerProfileContainer>
                <Typography>
                  <ReactMarkdown>
                    {selectedMarket.consumerProfile}
                  </ReactMarkdown>
                </Typography>
              </ConsumerProfileContainer>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <div>
            <Typography variant="body1">
              <b>Get in touch</b>
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.infoRows}>
          <div>
            <Typography>
              Need to know more about the situation in {selectedMarket.name}?
              Please contact our office.
            </Typography>
            <ButtonContainer>
              <Button
                variant="contained"
                target="_blank"
                size="small"
                href={selectedMarket.contactUrl}
              >
                Contact
              </Button>
            </ButtonContainer>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const PopulationGdpContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px;
  border-radius: 10px;
  background-color: white;
  box-shadow: 1px 1px 3px 0px #b8b8b8;
  width: 80%;
`;

const MarketName = styled(Typography)`
  color: #333333;
  margin-bottom: 10px;
`;

const GDP = styled(Typography)`
  font-weight: 600;
  margin: 10px;
  color: #333333;
`;

const Population = styled(Typography)`
  font-weight: 600;
  margin: 0px 10px 10px 10px;
  color: #333333;
`;

const ConsumerProfileContainer = styled.div`
  margin: 20px;
`;

const ButtonContainer = styled.div`
  margin: 20px 0px;
`;

export default DesktopMarketInfo;
